<template>
    <div class="view view__report_builder_execute">
        <report-builder-execute/>
    </div>
</template>

<script>

import ReportBuilderExecute from '@/components/ebs/reports/builder/execute/ReportBuilderExecute'

export default {
  name: 'view-report-builder-execute',
  components: { ReportBuilderExecute },
  methods: {
    clearReport () {
      this.$store.dispatch('ebsReportBuilderClear')
    },
    executeReport () {
      const routeName = this.$route.name
      let reportId
      let resultId
      let dispatchName
      let dispatchParams

      if (routeName === 'ebs-report-builder-execute-scheduled') {
        reportId = this.$route.params.reportId
        resultId = this.$route.params.resultId
        dispatchName = 'ebsReportBuilderExecuteScheduledReport'
        dispatchParams = { reportId, resultId }
      } else if (routeName === 'ebs-report-builder-execute') {
        reportId = this.$route.params.id
        dispatchName = 'ebsReportBuilderExecuteDefinedReport'
        dispatchParams = reportId
      }

      if (dispatchName && dispatchParams) {
        this.$eventBus.$emit('start-loading')
        this.$store.dispatch(dispatchName, dispatchParams).finally(() => {
          this.$eventBus.$emit('stop-loading')
        })
      }
    }
  },
  created () {
    this.executeReport()
  },
  beforeDestroy () {
    this.clearReport()
  }
}
</script>
